module.exports = __webpack_public_path__ + "img/cricketer.e2683eb3.png";